{
  "login": {
    "title": "Connexion",
    "subtitle": "Bienvenue sur ForumOne",
    "welcomeEmailHint": "Utilisez le mot de passe temporaire de votre e-mail de bienvenue pour vous connecter.",
    "noAccount": "Vous n'avez pas de compte ?",
    "signUpLink": "S'inscrire",
    "email": "E-mail",
    "identifier": "E-mail, nom d'utilisateur ou téléphone",
    "identifierPlaceholder": "E-mail, nom d'utilisateur ou numéro de téléphone",
    "password": "Mot de passe",
    "forgotPassword": "mot de passe oublié ?",
    "submit": "Se connecter",
    "submitting": "Connexion...",
    "welcomeBack": "Bon retour {{name}}",
    "failed": "Échec de la connexion"
  },
  "signup": {
    "title": "Inscription",
    "subtitle": "Créez votre compte entreprise ou institution",
    "hasAccount": "Vous avez déjà un compte ?",
    "signInLink": "Se connecter",
    "fullName": "Nom complet",
    "phone": "Numéro de téléphone",
    "username": "Nom d'utilisateur (optionnel)",
    "usernamePlaceholder": "Choisissez un nom d'utilisateur",
    "email": "E-mail",
    "password": "Mot de passe",
    "namePlaceholder": "Nom",
    "phonePlaceholder": "Téléphone",
    "emailPlaceholder": "e-mail",
    "passwordPlaceholder": "mot de passe",
    "submit": "Créer un compte",
    "submitting": "Création du compte...",
    "accountCreated": "Compte créé avec succès"
  },
  "resetPassword": {
    "documentTitle": "Réinitialiser le mot de passe",
    "enterEmail": {
      "title": "Saisir l’e-mail",
      "subtitle": "Un code de vérification sera envoyé à votre e-mail"
    },
    "verifyEmail": {
      "title": "Vérifier l’e-mail",
      "subtitle": "Un code de vérification a été envoyé à",
      "fallbackEmail": "votre e-mail"
    },
    "newPassword": {
      "title": "Réinitialiser le mot de passe",
      "subtitle": "Un code de vérification sera envoyé à votre e-mail. Saisissez le code et votre nouveau mot de passe."
    },
    "fields": {
      "email": {
        "label": "E-mail",
        "placeholder": "E-mail"
      },
      "verificationCode": {
        "label": "Code de vérification",
        "placeholder": "Code"
      },
      "newPassword": {
        "label": "Nouveau mot de passe",
        "placeholder": "Nouveau mot de passe"
      },
      "confirmNewPassword": {
        "label": "Confirmer le mot de passe",
        "placeholder": "Confirmer le mot de passe"
      }
    },
    "sendEmail": "Envoyer l’e-mail",
    "retrieving": "récupération...",
    "verify": "Vérifier",
    "verifying": "vérification...",
    "backToLogin": "Retour à la connexion",
    "toast": {
      "emailSent": "E-mail envoyé avec succès",
      "requestFailed": "Échec de la réinitialisation du mot de passe",
      "sendEmailFailed": "Échec de l’envoi de l’e-mail",
      "resetSuccess": "Mot de passe réinitialisé avec succès",
      "duplicateEntry": "Entrée en double trouvée",
      "accountVerified": "Compte vérifié avec succès",
      "verifyFailed": "Échec de la vérification du code"
    }
  },
  "selectBusiness": {
    "documentTitle": "Sélectionner une entreprise ou une institution",
    "title": "Gérez vos entreprises et institutions en un seul endroit",
    "subtitle": "Sélectionnez une entreprise ou une institution pour commencer, ou créez-en une nouvelle pour étendre votre présence.",
    "fallbackBusinessName": "Entreprise ou institution",
    "noDescription": "Aucune description",
    "chooseLocation": "Choisissez un emplacement pour continuer",
    "createCard": {
      "title": "Créer une nouvelle entreprise ou institution",
      "description": "Ajoutez une autre entreprise ou institution à votre compte"
    }
  },
  "selectConsoleScope": {
    "documentTitle": "Choisir un espace de travail",
    "title": "Où souhaitez-vous aller ?",
    "subtitle": "Vous avez accès à la console d’administration et aux outils d’entreprise ou d’institution. Nous mémoriserons votre choix pour la prochaine fois.",
    "adminCard": {
      "title": "Console d’administration",
      "description": "Gérez toutes les entreprises et institutions ainsi que les paramètres de la plateforme.",
      "cta": "Continuer en tant qu’admin"
    },
    "tenantCard": {
      "title": "Mon entreprise ou institution",
      "description": "Tableau de bord, services, rendez-vous et outils d’équipe.",
      "cta": "Continuer vers l’entreprise ou l’institution"
    },
    "toast": {
      "preferenceSaveError": "Impossible d’enregistrer la préférence. Réessayez."
    }
  },
  "linkBusinessOwner": {
    "documentTitle": "Lier un compte entreprise ou institution",
    "title": "Le compte existe déjà",
    "subtitlePrefix": "Cet e-mail est déjà enregistré. Si un administrateur a créé le profil de votre entreprise, utilisez le mot de passe temporaire de votre e-mail de bienvenue et",
    "signInLink": "connectez-vous",
    "subtitleSuffix": "au lieu de vous inscrire à nouveau.",
    "secondaryHint": {
      "prefix": "Sinon, saisissez votre mot de passe existant ci-dessous pour ajouter l’accès",
      "role": "propriétaire d’entreprise ou d’institution",
      "suffix": "au même identifiant."
    },
    "emailLabel": "E-mail",
    "nameOnSignupLabel": "Nom lors de l’inscription",
    "passwordLabel": "Mot de passe",
    "passwordPlaceholder": "Votre mot de passe existant",
    "submit": "Continuer",
    "submitting": "Vérification...",
    "wrongEmail": "Mauvais e-mail ?",
    "backToSignup": "Retour à l’inscription",
    "toast": {
      "startFromSignup": "Commencez par vous inscrire avec votre e-mail.",
      "linkedOwnerAccess": "Accès propriétaire d’entreprise ou d’institution lié à votre compte",
      "linkedVerifyEmail": "Lié — saisissez le code de vérification envoyé à votre e-mail",
      "linkError": "Impossible de lier le compte"
    }
  },
  "common": {
    "or": "ou",
    "termsPrefix": "En continuant, vous acceptez nos",
    "termsOfService": "Conditions d'utilisation",
    "and": "et notre",
    "privacyPolicy": "Politique de confidentialité"
  }
}
